import { __HttpRequestModel__ } from 'shared/domain/httpRequest/httpRequestModel';
import { AuthenticatedConfigProvider } from 'serviceWorker/services/config';
import { HeadersData } from '../../factories/types';
import { FetchRequest } from '../fetchRequest';
import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import { issueRequestBody } from './issueRequestData';

export class IssueRequestRunner implements IHttpRequestRunner {
  constructor(
    private getAuthenticatedConfig: AuthenticatedConfigProvider,
    private fetch: (
      headersData: HeadersData,
      httpRequest: FetchRequest,
      controller: AbortController
    ) =>
      | Promise<{
          status: number;
        }>
      | undefined
  ) {}
  async execute(request: __HttpRequestModel__): Promise<any> {
    const abortController = new AbortController();
    const setup = await this.getAuthenticatedConfig();
    if (!setup) {
      throw new Error('Cannot get config');
    }
    const response = this.fetch(
      setup,
      // Without a url `fetch` skips the request and the runner throws below.
      { method: request.method, url: request.url ?? '', data: issueRequestBody(request.data) },
      abortController
    );
    if (!response) {
      throw new Error('Cannot fetch.');
    }
    return response;
  }
}
